import React, { useEffect } from 'react'

import { useHeaderStore } from '@/stores/useHeaderStore/useHeaderStore'

interface TitleSetterProps {
  title?: string
  children?: React.ReactNode
}

export const TitleSetter: React.FC<TitleSetterProps> = ({ title, children }) => {
  const { setTitle } = useHeaderStore()

  useEffect(() => {
    if (title) {
      setTitle(title)
    }
  }, [title, setTitle])

  return <>{children}</>
}
